import { render } from "./ProjectVoteScore.vue?vue&type=template&id=2b3c219a"
import script from "./ProjectVoteScore.vue?vue&type=script&lang=js"
export * from "./ProjectVoteScore.vue?vue&type=script&lang=js"

import "./ProjectVoteScore.vue?vue&type=style&index=0&id=2b3c219a&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ProjectVoteScore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b3c219a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b3c219a', __exports__)) {
    api.reload('2b3c219a', __exports__)
  }
  
  module.hot.accept("./ProjectVoteScore.vue?vue&type=template&id=2b3c219a", () => {
    api.rerender('2b3c219a', render)
  })

}


export default __exports__